export default __webpack_public_path__ + "static/media/zodiac.2907037a.png";